"use client";

import { ArrowRight, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SecureTheLineSheet() {
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>();
  const {
    ref: subRef,
    isVisible: subVisible
  } = useRevealOnScroll<HTMLParagraphElement>();
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const tickerItems = ["PRECISION", "STRUCTURE", "TEXTILE", "ATELIER", "CRAFT", "PRECISION", "STRUCTURE", "TEXTILE", "ATELIER", "CRAFT"];
  return <section data-section-id="1269" id="secure-the-line-sheet" className="relative dark bg-background text-foreground overflow-hidden" style={{
    clipPath: "polygon(0 7%, 100% 0, 100% 100%, 0 100%)"
  }}>
      {}
      <div className="absolute z-10" style={{
      top: "calc(7% - 4px)",
      right: "0"
    }} aria-hidden="true">
        <div className="h-2 w-2 bg-accent-foreground" />
      </div>

      <div className="relative py-32 md:py-44 px-4 sm:px-8">
        {}
        

        {}
        <div className="relative max-w-[1100px] mx-auto">
          {}
          <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-center opacity-[0.08] select-none">
            <span className="font-default leading-none text-foreground" style={{
            fontSize: "clamp(18rem, 36vw, 36rem)",
            lineHeight: 0.8,
            transform: "scale(0.6)",
            transformOrigin: "center"
          }}>
              <span className="hidden md:inline" style={{
              fontSize: "1rem"
            }}>
                {}
              </span>
              <span className="block">ST</span>
            </span>
          </div>

          {}
          <h2 ref={headingRef} className={`relative font-default uppercase text-center mx-auto transition-all duration-700 ease-out ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          fontSize: "clamp(2.5rem, 6vw, 5.5rem)",
          fontWeight: 400,
          letterSpacing: "-0.005em",
          lineHeight: 0.92
        }}>
            SECURE THE{" "}
            <em className="not-italic" style={{
            color: "var(--accent-foreground)",
            fontStyle: "italic",
            display: "inline-block"
          }}>
              <span style={{
              fontStyle: "italic"
            }}>TECHNICAL</span>
            </em>{" "}
            ARCHIVE.
          </h2>

          {}
          <p ref={subRef} className={`relative mt-8 md:mt-10 text-center mx-auto max-w-2xl font-sans text-foreground/80 transition-all duration-700 ease-out delay-100 ${subVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          fontSize: "clamp(1.0625rem, 1.2vw, 1.25rem)",
          lineHeight: 1.6
        }}>
            Access the full digital line sheet for our latest collection. Precision engineering meets luxury streetwear.
          </p>

          {}
          <div ref={ctaRef} className={`relative mt-12 md:mt-16 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-4 transition-all duration-700 ease-out delay-200 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            <Link to="/CollectionsPage" className="block w-full sm:w-auto">
              <Button className="group relative w-full sm:w-auto h-16 px-10 bg-foreground text-background hover:bg-accent-foreground uppercase font-default tracking-[0.05em] text-base overflow-hidden border-0 transition-colors duration-300" style={{
              borderRadius: 0
            }}>
                <span aria-hidden="true" className="absolute inset-y-0 -left-full w-full bg-accent-foreground transition-all duration-300 ease-out group-hover:left-0" style={{
                transform: "skewX(-7deg)"
              }} />
                <span className="relative flex items-center gap-3">
                  DOWNLOAD LINE SHEET
                  <ArrowRight className="size-5" />
                </span>
              </Button>
            </Link>

            <Link to="/InquiriesPage" className="block w-full sm:w-auto">
              <Button variant="outline" className="w-full sm:w-auto h-16 px-10 bg-transparent border-2 border-foreground text-foreground hover:bg-foreground hover:text-background hover:border-foreground uppercase font-default tracking-[0.05em] text-base transition-colors duration-300" style={{
              borderRadius: 0
            }}>
                <span className="flex items-center gap-3">
                  <Phone className="size-5" />
                  CONTACT ATELIER
                </span>
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="relative border-t border-b border-foreground/15 py-6 overflow-hidden">
        <div className="flex whitespace-nowrap" style={{
        animation: "ticker-scroll 40s linear infinite"
      }}>
          {[...tickerItems, ...tickerItems].map((item, i) => <div key={i} data-index={i} className="flex items-center gap-8 px-8 font-default uppercase text-foreground" style={{
          fontSize: "clamp(1.5rem, 3vw, 2.5rem)",
          letterSpacing: "0.02em",
          lineHeight: 1
        }}>
              <span>{item}</span>
              <span className="text-accent-foreground">·</span>
            </div>)}
        </div>
        <style>{`
          @keyframes ticker-scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
      </div>
    </section>;
}